import { defineComponent as _defineComponent } from 'vue'
import { PropType } from 'vue'
import Irmao from '../../../../common/types/Irmao'
import { adicionarBuscaRecente } from '@/shareds/buscasRecentes'
import { ResultadoBusca } from '../../../../common/types/Busca'
import { useRouter } from '@/composables/router'


export default /*#__PURE__*/_defineComponent({
  __name: 'ItemEsposa',
  props: {
	item: { type: Object as PropType<Irmao>, required: true },
},
  setup(__props) {

const props = __props;



const router = useRouter()

function onClickItemBusca() {
	adicionarBuscaRecente(props.item as unknown as ResultadoBusca)
	router.push({
		name: 'detalhar-irmao',
		params: { id: props.item._id },
	})
}

return { __sfc: true,props, router, onClickItemBusca }
}

})